import type { Property } from '@/domain/properties';
import { getAddressDescription } from '@/utils/addresses';
import GoogleMapReact from 'google-map-react';
import { type FC } from 'react';

interface Props {
  property: Property;
}

const apiKey = process.env.GMAPS_API_KEY ?? '';

const PropertyLocationCard: FC<Props> = ({ property }) => {
  if (!property.address?.location) {
    return null;
  }

  return (
    <div className="bg-white p-8 rounded-none border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Location</h2>
      <div className="h-[400px] rounded-none overflow-hidden">
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey }}
          center={{
            lat: property.address.location.latitude,
            lng: property.address.location.longitude,
          }}
          yesIWantToUseGoogleMapApiInternals
          zoom={15}
          options={{
            styles: [
              {
                featureType: 'all',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: '#on',
                  },
                ],
              },
            ],
          }}
          onGoogleApiLoaded={({ map, maps }) => {
            new maps.Marker({
              position: {
                lat: property.address?.location?.latitude,
                lng: property.address?.location?.longitude,
              },
              map,
              title: getAddressDescription(property.address),
            });
          }}
        />
      </div>
      <p className="text-gray-600 mt-4">
        <strong>Address:</strong> {getAddressDescription(property.address)}
      </p>
    </div>
  );
};

export default PropertyLocationCard;
